import axios from "axios";


const HOST = ''


export const _GET = (url, filter, authToken) => axios.get(HOST + url + convertFilter(filter), createConfig(url, authToken)).then(processSuccess).catch(processError)
export const _POST = (url, body, authToken) => axios.post(HOST + url, body, createConfig(url, authToken)).then(processSuccess).catch(processError)
export const _PUT = (url, body, authToken) => axios.put(url, body, createConfig(url, authToken)).then(processSuccess).catch(processError)
export const _DELETE = (url, authToken) => axios.delete(HOST + url, createConfig(url, authToken)).then(processSuccess).catch(processError)




const createConfig = (url, authToken) => {
    let config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    if (authToken) {
        config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken
            }
        };
    }
    return config
}

const convertFilter = (filter) => {
    let queryFilter = ''
    if(filter != null) {
        let filterCopy = JSON.parse(JSON.stringify(filter))
        Object.keys(filterCopy).forEach((key) => (filterCopy[key] == null) && delete filterCopy[key]);
        queryFilter = '?' + new URLSearchParams(filterCopy).toString()
    }
    return queryFilter
}

const processSuccess = (response) => {
    return new Promise(function(resolve, reject) {
        resolve(Promise.resolve(response));
    })
}

const processError = (error) => {
    if(error.response.status == 401) {
        localStorage.clear()
        window.location.href = "/";
    } else {
        alert(error.response.data.message)
    }
    return Promise.reject(error)
}


